import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-ticket-media',
  name: '票种banner',
  icon: '票',
  group: '门票详情',
  description: '票种详情顶部主视觉大图横幅。',
  defaultProps: {
    title: '票种主图',
    imageUrl: ''
  }
}
